import { tmxApiCall } from './index'

// Utilities
import Logger from '../utility/loggerUtil'

export default {
  async getStoreDetails (storeId, mobileMoneyLocation = undefined, mobileMoneyType = undefined, storeNumber) {
    Logger.info('Started Get Store Details query.')
    return tmxApiCall('get', '/store', {
      params: {
        storeId,
        mobileMoneyLocation,
        mobileMoneyType,
        storeNumber
      }
    })
  },

  async getStoreMapImage (storeId) {
    Logger.info('Started Get Store Map query.')
    return tmxApiCall('get', '/storemap', {
      params: {
        storeId
      }
    }).then(data => `data:image/png;base64,${data}`)
  }
}
